import * as DateF from 'date-fns'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Referee } from '@root/entities/referral'
import { DATE_FORMAT } from '@root/shared'

import type { Column, DataTableCellProps } from '@root/shared/ui-kit'

const Name = ({ value: referee }: DataTableCellProps<Referee.Referee>) => {
  const fullName = useMemo(() => Referee.displayName(referee), [referee])
  return <PrimaryCell>{fullName}</PrimaryCell>
}

export const referralTableColumns: Array<Column<Referee.Referee>> = [
  {
    id: 'index' as const,
    header: () => '#',
    render: ({ index }) => (
      <Index>{(index + 1).toString().padStart(2, '0')}</Index>
    ),
    width: 26,
  },
  {
    id: 'username' as const,
    header: ({ t }) => t('auth.username'),
    render: Name,
    minWidth: 100,
  },
  {
    id: 'date' as const,
    header: ({ t }) => t('common.date'),
    render: ({ value: referee }) => (
      <DateCell>
        {DateF.format(referee.referralDate, DATE_FORMAT.dd_MM_yy)}
      </DateCell>
    ),
    minWidth: 100,
    justify: 'center',
  },
  {
    id: 'profit' as const,
    header: ({ t }) => t('common.profit'),
    render: ({ value: referee }) => (
      <PrimaryCell>
        <Numeric
          value={referee.tradingProfitUsd}
          currency="$"
          preset="currency-amount-short"
        />
      </PrimaryCell>
    ),
    minWidth: 100,
    justify: 'end',
  },
]

const Index = styled.div`
  color: rgba(var(--background-12-rgb), 0.25);

  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

const PrimaryCell = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const DateCell = styled.div`
  color: var(--text-9);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
